import {envIsIntegration, envIsLocal} from '../config';
import {useViewer} from '../state/viewer/hooks';
import {type Viewer} from '../state/viewer/types';
import {
  ALL_FEATURE_FLAGS,
  type FeatureFlag,
  type FeatureKey,
  WANDB_EMPLOYEES,
} from './featureFlags';
import {getViewerIsWandbEmployee} from './useBetaFeature';

export const useFeatureFlagVegaEnabled = (entityName: string) => {
  return checkFeatureFlag({
    featureKey: 'vega-panel',
    enabledFor: entityName,
  });
};

export const useFeatureFlagDisableFuzzySearch = (entityName: string) => {
  return checkFeatureFlag({
    featureKey: 'disable-fuzzy-search',
    enabledFor: entityName,
  });
};

// This is a feature flag that's gated to a user's entities
export const useFeatureFlagWorkspaceOptimizations = () => {
  return checkOrgFeatureFlag('workspace-optimizations', useViewer());
};

export const checkOrgFeatureFlag = (
  featureKey: FeatureKey,
  viewer: Viewer | undefined
) => {
  const viewerOrgs = viewer?.organizations.map(org => org.name) ?? [];

  return (
    // wandb employees aren't all in the same org, so have a special case for that.
    (ALL_FEATURE_FLAGS[featureKey][WANDB_EMPLOYEES] &&
      getViewerIsWandbEmployee(viewer)) ||
    viewerOrgs.some(orgName =>
      checkFeatureFlag({
        featureKey,
        enabledFor: orgName,
      })
    )
  );
};

/**
 * THIS IS NOT A HOOK - therefore the `use-` prefix will cause lint errors if it's called conditionally or inside a callback. In reality that's fine UNLESS someone adds some React goodies inside this function to make it an actual hook.
 */
export const checkFeatureFlag = ({
  featureKey,
  enabledFor,
}: FeatureFlag): boolean => {
  // All features are enabled for CI
  if (envIsIntegration) {
    return true;
  }

  // Enable vega panels in local
  if (envIsLocal && featureKey === 'vega-panel') {
    return true;
  }
  return ALL_FEATURE_FLAGS[featureKey][enabledFor] === 1;
};
